export default state => ({
  ...state,
  validationResults: {},
});
